import { render, staticRenderFns } from "./ClaimDocuments.vue?vue&type=template&id=4984d166&"
import script from "./ClaimDocuments.vue?vue&type=script&lang=js&"
export * from "./ClaimDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports